import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { Question, QuestionAnswers } from "../../../../Interface/Index";
import "./descriptiveQuestion.scss";

interface DescriptiveQuestionProps {
  question: Question;
  questionAnswer: QuestionAnswers;
  isRoundFinished: boolean;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const DescriptiveQuestion: React.FC<DescriptiveQuestionProps> = ({
  question,
  isRoundFinished,
  questionAnswer,
  onChange,
}) => {
  const isDisabled =
    (question.responses && question.responses.length > 0) || isRoundFinished;

  const getInitialAnswer = () => {
    return isDisabled
      ? question?.responses?.[0]?.description ?? ""
      : questionAnswer?.answer ?? "";
  };

  const [answer, setAnswer] = useState<string>(getInitialAnswer());

  useEffect(() => {
    setAnswer(getInitialAnswer());
  }, [question?._id]);

  const updateParentState = (value: string) => {
    const syntheticEvent = {
      target: { value },
    } as React.ChangeEvent<HTMLTextAreaElement>;
    onChange(syntheticEvent);
  };

  const handleInput = (e: React.FormEvent<HTMLTextAreaElement>) => {
    const value = (e.target as HTMLTextAreaElement).value;
    setAnswer(value);
    updateParentState(value);
  };

  return (
    <div className="descriptive-question-container">
      <Input.TextArea
        rows={6}
        placeholder="Type your answer here"
        value={answer}
        onInput={handleInput}
        disabled={isDisabled}
      />
    </div>
  );
};

export default DescriptiveQuestion;
